module.exports = __webpack_public_path__ + "img/cavil-grey.fdc9c111.jpg";